
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import PositionList, {
  Industry,
  Position,
  PositionIndustryList,
  Template
} from "@/lib/position/position";
import { Dimension } from "@/lib/dimension/dimension";
import Loading from "@/components/loading.vue";
import TemplateDetail from "./templateDetail.vue";
import vuexStore from "@/store/vuex-store";
import UpgradeUser from "@/components/UpgradeUser.vue";

// import { ExamV2Custom, Template } from "@/lib/model/exambuilder/exam-v2";
class TemItem {
  industryName = "";
  list: Template[] = [];
}

@Component({ components: { Loading, TemplateDetail, UpgradeUser } })
export default class TemplateDialog extends Vue {
  @Prop({}) exam!: any;
  loading = true;
  showDetail = false;
  showUpgrade = false;
  detailTemp = new Template(); //预览的模板
  title = "新建短信通知模板";
  positionIndustryList = new PositionIndustryList();
  dimensionList: Dimension[] = []; //维度列表
  templateList: Template[] = []; //模板列表
  search = {
    name: ""
  };

  allIndustry = new Industry(); //行业 模拟全部
  defIndustryId = 99999; //全部行业用id

  allPosition = new Position(); //职位 模拟全部
  defPositionId = 99999; //全部职位用id

  defDimensionId = 99999; //全部维度用id

  industryId = this.defIndustryId; //选中行业id
  positionId = this.defPositionId; //选中职位id
  dimensionId = this.defDimensionId; //选中维度id

  loadingStart = 0; //加载开始时间
  index = 0;
  curGroup = -1;
  disabled = "";

  async created() {
    //全部  模拟赋值
    this.allIndustry.name = "全部";
    this.allIndustry.questionIndustryId = this.defIndustryId;
    this.allPosition.name = "全部";
    this.allPosition.questionPositionId = this.defPositionId;

    this.getPosition();
    this.getDimension();
    this.getTemplate();
  }
  mounted() {
    const a = this.exam;
    console.log(a);
  }

  //拉行业和岗位
  async getPosition() {
    await PositionList.get().then((res: PositionIndustryList) => {
      this.positionIndustryList = res;
    });
  }

  selectIndustry(it: Industry) {
    this.industryId = it.questionIndustryId;
    this.getDimension();
    this.getTemplate();
  }

  //拉维度
  getDimension() {
    const p = {
      questionPositionIdList:
        this.positionId === this.defPositionId ? [] : [this.positionId],
      questionIndustryIdList:
        this.industryId === this.defIndustryId ? [] : [this.industryId]
    };
    PositionList.getDimensionList(p).then((res: any) => {
      this.dimensionList = res.list;
    });
  }

  // 拉模板
  getTemplate() {
    const p = {
      questionPositionIdList:
        this.positionId === this.defPositionId ? [] : [this.positionId],
      questionIndustryIdList:
        this.industryId === this.defIndustryId ? [] : [this.industryId],
      dimensionKey:
        this.dimensionId === this.defDimensionId ? "" : this.dimensionId,
      nameLike: this.search.name,
      returnAll: true
    };
    this.loading = true;
    this.loadingStart = new Date().getTime();
    PositionList.getTemplateList(p)
      .then((res: any) => {
        this.templateList = [];
        res.list.forEach((d: Template) => {
          this.templateList.push(new Template().assign(d));
        });
        this.endLoading();
      })
      .finally(() => {
        this.endLoading();
      });
  }
  //保证最少300ms loading
  endLoading() {
    const now = new Date().getTime();
    const time = now - this.loadingStart;
    if (time < 300) {
      setTimeout(() => {
        this.loading = false;
      }, 300 - time);
    } else {
      this.loading = false;
    }
  }

  //模板按照行业分组
  get getTemplateListByGroup() {
    const list: TemItem[] = [];
    this.templateList.forEach((d, i) => {
      const item = list.find(it => it.industryName === d.questionIndustryName);
      if (item) {
        item.list.push(d);
      } else {
        const newItem = new TemItem();
        newItem.industryName = d.questionIndustryName;
        newItem.list.push(d);
        list.push(newItem);
      }
    });
    return list;
  }

  // 使用模板
  useTemplate(temp?: Template) {
    this.loading = true;
    //vip check
    if (temp?.vipLevel === 10 && vuexStore.companyPower.vipLevel < 10) {
      this.showUpgrade = true;
      this.loading = false;
      return;
    }
    //跳创建
    if (temp) {
      this.$router.push("/ai-builder?step=0&templateId=" + temp?.templateId);
    } else {
      this.$router.push("/ai-builder?step=0");
    }
  }

  show(it: Template, n: number, curGroup: number) {
    let totalCount = 0;
    this.getTemplateListByGroup.forEach(el => {
      totalCount += el.list.length;
    });
    this.curGroup = curGroup;
    this.index = n;
    this.detailTemp = it;
    this.showDetail = true;
    if (totalCount === 1) {
      this.disabled = "prenext";
    } else if (this.curGroup === 0 && n === 0) {
      this.disabled = "pre";
    } else if (
      this.curGroup === this.getTemplateListByGroup.length - 1 &&
      n ===
        this.getTemplateListByGroup[this.getTemplateListByGroup.length - 1].list
          .length -
          1
    ) {
      this.disabled = "next";
    } else {
      this.disabled = "";
    }
  }

  watch(differ: number) {
    const curGroupLen = this.getTemplateListByGroup[this.curGroup].list.length;
    if (differ >= 0 && differ < curGroupLen) {
      // 当前组内上下页
      this.detailTemp = this.getTemplateListByGroup[this.curGroup].list[differ];
      this.index = differ;
    } else if (differ < 0) {
      // 上一组最后一页
      const preGroupLen = this.getTemplateListByGroup[this.curGroup - 1].list
        .length;
      this.detailTemp = this.getTemplateListByGroup[this.curGroup - 1].list[
        preGroupLen - 1
      ];
      this.index = preGroupLen - 1;
      this.curGroup = this.curGroup - 1;
    } else {
      // 下一组第一页
      this.detailTemp = this.getTemplateListByGroup[this.curGroup + 1].list[0];
      this.index = 0;
      differ = 0;
      this.curGroup = this.curGroup + 1;
    }
    // 设置第一页最后一页翻页状态
    if (this.curGroup === 0 && differ === 0) {
      this.disabled = "pre";
    } else if (
      this.curGroup === this.getTemplateListByGroup.length - 1 &&
      differ ===
        this.getTemplateListByGroup[this.getTemplateListByGroup.length - 1].list
          .length -
          1
    ) {
      this.disabled = "next";
    } else {
      this.disabled = "";
    }
  }

  ok() {
    this.$emit("ok", this.exam.templateName);
    //
  }

  //关闭
  close() {
    this.$emit("cancel", false);
  }
}
